import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'

import { paymentsService } from 'src/services/payments.service'
import { QUERY_KEYS } from 'src/constants'

const useAccountTransactions = () => {
  const { accountId } = useParams()
  return useQuery([QUERY_KEYS.ACCOUNT_TRANSACTIONS, accountId], async () => {
    if (!accountId) return null

    return paymentsService.retrieveAccountTransactions(accountId)
  })
}

export { useAccountTransactions }
